<style>
    .ivu-tabs {
        min-height: 600px;
    }
</style>
<template>
    <div>
        <card style="">
            <Tabs v-model="paramtype" @on-click="changeType" :animated="false">
                <TabPane label="学生信息" name="detail">
                    <detail ref="detail"></detail>
                </TabPane>
                <TabPane label="联系人信息" name="parents" v-if="showPane">
                    <parents ref="parents"></parents>
                </TabPane>
                <!--<TabPane label="科目信息" name="course" v-if="showPane">-->
                <!--<course ref="course"></course>-->
                <!--</TabPane>-->
                <!--<TabPane label="课程信息" name="classes" v-if="showPane">-->
                <!--<classes ref="classes"></classes>-->
                <!--</TabPane>-->
                <TabPane label="课程" name="clazz" v-if="showPane">
                    <clazz ref="clazz"></clazz>
                </TabPane>
                <TabPane label="排课" name="schedule" v-if="showPane">
                    <schedule ref="schedule"></schedule>
                </TabPane>
                <TabPane label="课时记录" name="classHourRecord" v-if="showPane">
                    <classHourRecord ref="classHourRecord"></classHourRecord>
                </TabPane>
                <TabPane label="缴费记录" name="finRecord" v-if="showPane">
                    <finRecord ref="finRecord"></finRecord>
                </TabPane>
            </Tabs>
        </card>
    </div>
</template>
<script>
  import detail from './detail'
  import parents from './parents'
  // import course from './course'
  // import classes from './classes'
  // import pay from './pay'
  import clazz from './clazz'
  import classHourRecord from './classHourRecord'
  import finRecord from './finRecord'
  import schedule from './schedule'

  export default {
    name: 'student_detail',
    components: {
      detail,
      parents,
      clazz,
      classHourRecord,
      finRecord,
      schedule
      // course,
      // classes,
      // pay
    },
    data() {
      return {
        paramtype: 'detail',
      }
    },
    mounted() {
        this.changeType()
    },
    activated(){
        //this.changeType()
    },
    computed: {
      showPane() {
        if (this.$route.query.id != null)
          return true
        else
          return false
      }
    },
    methods: {

      changeType() {
        switch (this.paramtype) {
          case"detail":
            this.$refs.detail.init()
            if (this.$route.query.id != null) {
              this.$refs.detail.readonly = true;
              this.$refs.detail.detailForm.id = this.$route.query.id
              this.$refs.detail.getStudentDetail()
            }
            break;
          case"classHourRecord":
            if (this.$route.query.id != null) {
              this.$refs.classHourRecord.getList()
            }
            break;
          case"clazz":
            if (this.$route.query.id != null) {
              this.$refs.clazz.getList()
            }
            break;
          case"schedule":
            if (this.$route.query.id != null) {
              this.$refs.schedule.getList()
            }
            break;
          case"finRecord":
            if (this.$route.query.id != null) {
              this.$refs.finRecord.getList()
            }
            break;
          // case"parents":
          //   if (this.$route.query.id != null) {
          //     this.$refs.parents.getParentsList()
          //   }
          //   break;
          // case"course":
          //   if (this.$route.query.id != null) {
          //     this.$refs.course.getCourseList()
          //   }
          //   break;
          // case"classes":
          //   if (this.$route.query.id != null) {
          //     this.$refs.classes.getClassList()
          //   }
          //   break;
          // case"pay":
          //   this.$refs.pay.getCourseList()
          //   if (this.$route.query.id != null) {
          //     this.$refs.pay.getPayList()
          //   }
          //   break;
          default:
            break;
        }
      }
    },
    watch: {
        '$route': 'changeType'
    },

  }
</script>
